export type AnalyticsContextValue = string | number;
export type AnalyticsContext = Record<string, AnalyticsContextValue>;

const getDeviceType = (userAgent: string): string => {
  if (/ipad|tablet|playbook|silk/i.test(userAgent)) {
    return 'tablet';
  }

  if (
    /mobi|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  ) {
    return 'mobile';
  }

  return 'desktop';
};

const getBrowser = (userAgent: string): string => {
  if (/edg\//i.test(userAgent)) return 'edge';
  if (/opr\//i.test(userAgent)) return 'opera';
  if (/chrome\//i.test(userAgent) && !/edg\//i.test(userAgent)) {
    return 'chrome';
  }
  if (/safari\//i.test(userAgent) && !/chrome\//i.test(userAgent))
    return 'safari';
  if (/firefox\//i.test(userAgent)) return 'firefox';
  if (/trident|msie/i.test(userAgent)) return 'ie';
  return 'unknown';
};

const getOs = (userAgent: string): string => {
  if (/windows nt/i.test(userAgent)) return 'windows';
  if (/mac os x/i.test(userAgent)) return 'macos';
  if (/android/i.test(userAgent)) return 'android';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
  if (/linux/i.test(userAgent)) return 'linux';
  return 'unknown';
};

export const getAnalyticsContext = (): AnalyticsContext => {
  if (typeof window === 'undefined') {
    return {
      env: process.env.NODE_ENV || 'unknown',
      app_version: process.env.REACT_APP_VERSION || 'unknown',
      page: 'unknown',
      browser: 'unknown',
      os: 'unknown',
      device_type: 'unknown',
    };
  }

  const userAgent = window.navigator.userAgent || '';
  const page = window.location.pathname || '/';
  const effectiveType = (
    window.navigator as Navigator & {
      connection?: { effectiveType?: string };
    }
  ).connection?.effectiveType;

  return {
    env: process.env.NODE_ENV || 'unknown',
    app_version: process.env.REACT_APP_VERSION || 'unknown',
    page,
    browser: getBrowser(userAgent),
    os: getOs(userAgent),
    device_type: getDeviceType(userAgent),
    network_type: effectiveType || 'unknown',
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    timezone:
      Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Paris',
    language: window.navigator.language || 'unknown',
  };
};
